// @ts-nocheck
import React, {useState} from 'react'
import Popup from '../../../../components/Popup'
import Spinner from '../../../../components/Spinner'
import TargetColorBox from '../../../TargetingV2/components/TargetColorBox'
import styles from '../css/EditTarget.module.css'
import arrow from '../../../../assets/purple-arrow.png'

function EditTarget(props) {

    const [reason, setReason] = useState(props.reason || "")
    const [notes, setNotes] = useState(props.notes || "")
    const [error, setError] = useState("")
    const [isValid, setIsValid] = useState(true)
    const [isNotesValid, setIsNotesValid] = useState(true)
    const [wiggle, setWiggle] = useState(false)

    // Determine direction from target comparison (alphabetically higher = lower priority = downgrade)
    const isUpgrade = props.targetType < props.data.CURRENT_TARGET_VALUE
    const direction = isUpgrade ? 'upgrading' : 'downgrading'

    // Support both the new { upgrade, downgrade } shape and the legacy flat array
    const optionCodes = Array.isArray(props.options)
        ? props.options
        : (isUpgrade ? (props.options?.upgrade ?? []) : (props.options?.downgrade ?? []))

    const hasReasonCodes = optionCodes.length > 0
    const notesRequired = reason.toLowerCase() === 'other'

    let optionsList = [<option key="" value=""></option>]
    for (let i = 0; i < optionCodes.length; i++) {
        optionsList.push(<option key={optionCodes[i]} value={optionCodes[i]}>{optionCodes[i]}</option>)
    }

    let name = props.exercise.CUSTOMER_TYPE === "HCP" ? `${props.data.FIRST_NAME}${props.data.MIDDLE_NAME ? " " + props.data.MIDDLE_NAME + " " : " "}${props.data.LAST_NAME}, ${props.data.DEGREE}` : props.data.NAME
    let body = <Spinner />
    if (props.success) {
        body = (
            <div className={"pop-body"}>
                <div className={"pop-required"}>REQUIRED FIELD *</div>
                <div className={"pop-required"}>{error}</div>
                <div className={"pop-titleRow"}>
                    <div className={"pop-side"}></div>
                    <div className={"pop-directions"}>You are {direction} the target type of</div>
                    <div className={"pop-side"}></div>
                </div>
                <div className={"pop-content"}>
                    <div className={styles.name}>{name}</div>
                    <div className={styles.middle}>
                        <div className={styles.setmiddle}>
                            <div className={styles.key}>CURRENT TARGET TYPE</div>
                            <TargetColorBox target={props.data.CURRENT_TARGET_VALUE}/>
                        </div>
                        <img className={styles.arrow} src={arrow} alt=""/>
                        <div className={styles.setmiddle}>
                            <div className={styles.key}>CHANGE TARGET TYPE</div>
                            <TargetColorBox target={props.targetType}/>
                        </div>
                    </div>
                    <div className={"flex-col flex-justify-start"}>
                        {hasReasonCodes && (
                        <div className={styles.set}>
                            <div className={styles.reason}>REASON <div className={"pop-required"}>*</div></div>
                            <select className={isValid ? styles.default : styles.error} value={reason} onChange={(event) => {
                                    setReason(event.target.value)
                            }} disabled={props.lock} style={props.lock ? {backgroundColor: "#d9d5d4", border: "none"} : {}}>
                                {optionsList}
                            </select>
                        </div>
                        )}
                        <div className={styles.set}>
                            <div style={{ display: 'flex', gap: 4 }}>NOTES {notesRequired && <div className={"pop-required"}>*</div>}</div>
                            <textarea className={[styles.notes, isNotesValid ? styles.default : styles.error].join(" ")} value={notes} onChange={(event) => {
                                    setNotes(event.target.value)
                                    if (event.target.value.trim() !== '') setIsNotesValid(true)
                            }} disabled={props.lock} style={props.lock ? {backgroundColor: "#d9d5d4", border: "none"} : {}}/>
                        </div>
                    </div>
                    <div className={"pop-buttonRow"}>
                        <button type="button" id={"pop-cancel"} onClick={() => {
                                props.close()
                            }
                        }>CLOSE</button>
                    <button className={wiggle ? "wiggle" : ""} id={"pop-submit"} onClick={() => {
                            const reasonOk = !hasReasonCodes || reason !== ""
                            const notesOk = !notesRequired || notes.trim() !== ""
                            if (reasonOk && notesOk) {
                                props.submit(props.targetType, { reason, notes })
                            } else {
                                setWiggle(true)
                                if (!reasonOk) {
                                    setIsValid(false)
                                    setError(`PLEASE SELECT A REASON FOR ${direction.toUpperCase()}`)
                                } else {
                                    setIsNotesValid(false)
                                    setError('PLEASE PROVIDE A RATIONALE WHEN SELECTING "OTHER"')
                                }
                                setTimeout(() => { setWiggle(false) }, 500)
                            }
                        }} disabled={props.lock} style={props.lock ? {backgroundColor: "#d9d5d4", border: "none"} : {}}>SUBMIT</button>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <Popup {...props} body={body} title={"Edit Target"} />
    )

}

export default EditTarget
